export const LOCAL_STORAGE_TOKEN = '97a0501d-9880-4f47-bd39-baf5a25aecad'